import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

if (import.meta.env.DEV) {
  console.log('[i18n] Browser languages:', navigator.languages || [navigator.language]);
  console.log('[i18n] Stored language:', localStorage.getItem('i18nextLng'));
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: import.meta.env.DEV,
    
    // Define the namespaces we're using
    ns: ['common', 'investigator', 'search', 'audit', 'analytics', 'compliance', 'dashboard', 'pages', 'landing', 'whitepaper', 'transactions', 'users', 'evidence', 'trustScore', 'navigation', 'certificationAuthority'],
    defaultNS: 'common',
    
    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    backend: {
      // Keep URLs stable so translation responses can be cached effectively.
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      // Order of language detection methods - prioritize user preferences
      order: ['localStorage', 'navigator', 'cookie', 'htmlTag', 'querystring'],
      
      // Look for language in localStorage (user's saved preference)
      lookupLocalStorage: 'i18nextLng',
      
      // Look for language in cookie
      lookupCookie: 'i18next',
      
      // Look for language in query parameter (e.g., ?lng=fr)
      lookupQuerystring: 'lng',
      
      // Cache the detected language
      caches: ['localStorage', 'cookie'],
      
      // Cookie options
      cookieMinutes: 10080, // 7 days
      
      // Convert browser language codes to our supported languages
      convertDetectedLanguage: (lng: string) => {
        // Handle language variants
        if (lng.startsWith('fr')) return 'fr'; // French variants
        if (lng.startsWith('en')) return 'en'; // English variants
        
        // Default to English for unsupported languages
        return 'en';
      },
    },

    // Supported languages
    supportedLngs: ['en', 'fr'],

    // Non-explicit fallback
    nonExplicitSupportedLngs: true,
  });

if (import.meta.env.DEV) {
  i18n.on('languageChanged', (lng) => {
    console.log(`[i18n] Language changed to: ${lng}`);
    document.documentElement.lang = lng; // Update HTML lang attribute
  });
} else {
  i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng; // Update HTML lang attribute
  });
}

if (import.meta.env.DEV) {
  i18n.on('initialized', () => {
    console.log(`[i18n] Initialized with language: ${i18n.language}`);
    console.log(`[i18n] Detected languages:`, i18n.services?.languageDetector?.detectors || []);
  });
} else {
  i18n.on('initialized', () => {
    // Set lang at startup for accessibility and SEO.
    document.documentElement.lang = i18n.language || 'en';
  });
}
